import Component from "@lib/Component.js";
import YouTubePlayer from "youtube-player";
import CustomEventType from "@lib/helpers/CustomEventType.js";

export default class ModelVideo extends Component {
  init() {
    super.init();

    this.createElement();

    this.player = YouTubePlayer(this.refs.player, {
      width: this.refs.player.clientWidth,
      height: this.refs.player.clientHeight,
      playerVars: {
        autoplay: 0,
        color: "white",
        controls: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        rel: 0,
        showinfo: 0
      }
    });

    this.addListeners();
  }

  addListeners() {
    document.addEventListener(CustomEventType.MODALVIDEO, this);

    this.refs.bg.addEventListener("click", this);
  }

  handleEvent(event) {
    if (event.type === CustomEventType.MODALVIDEO) {
      if (event.detail && event.detail.type === "dubicast") {
        this.refs.dubicastplayer.innerHTML = `<iframe class="modal-player" src="${event.detail.url}" allowfullscreen="allowfullscreen" allow="autoplay"></iframe>`;
      } else {
        this.loadVideoById(event.detail);
      }
      this.show();
    }

    if (event.type === "click" && event.currentTarget === this.refs.bg) {
      this.hide();
    }
  }

  show() {
    this.el.classList.add("show");
  }

  hide() {
    this.player.stopVideo();
    this.refs.dubicastplayer.innerHTML = "";
    this.el.classList.remove("show");
  }

  loadVideoById(youtubeId) {
    this.player.loadVideoById(youtubeId);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/ModalVideo.js